
const ENVIRONMENT_TO_DOMAIN_MAP = {
  DEVELOPMENT: "https://develop.spotlyte.mwkci.com",
  STAGING: "https://stage.spotlyte.mwkci.com",
  DEPLOY: "https://deploy-preview-94--thespotlyte.netlify.com"
};

const MODEL_TYPE_TO_PREVIEW_ROUTE_MAP = {
  home_page: "preview/static/home",
  about_page: "preview/static/about",
  contact_page: "preview/static/contact",
  legal_page: "preview/static/legal",
  privacy_page: "preview/static/privacy",
  treatment_guides_page: "preview/static/treatment-guides",
  sign_up_page: "preview/static/signup",
};

function get_preview_url(ITEM_ID, CURRENT_ENVIRONMENT, MODEL_TYPE) {
  const DOMAIN = ENVIRONMENT_TO_DOMAIN_MAP[CURRENT_ENVIRONMENT];
  const ROUTE = MODEL_TYPE_TO_PREVIEW_ROUTE_MAP[MODEL_TYPE];

  return [DOMAIN, ROUTE, ITEM_ID].join("/");
}

export default get_preview_url;
